import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { EnvelopeSimple, ArrowLeft, CheckCircle } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Kontrol edin — talebiniz alındı");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Bir hata oluştu");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <Card className="w-full max-w-md rounded-sm border-border">
        <CardContent className="p-8">
          <button
            onClick={() => nav("/login")}
            className="text-xs text-muted-foreground uppercase tracking-widest mb-4 inline-flex items-center gap-1 hover:text-primary"
            data-testid="forgot-back-btn"
          >
            <ArrowLeft size={12} /> Girişe dön
          </button>
          <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-2">
            Otopark Yönetim
          </div>
          <h2 className="text-3xl font-bold tracking-tight mb-6">Şifremi Unuttum</h2>

          {sent ? (
            <div className="space-y-4 text-center py-6">
              <CheckCircle size={48} weight="fill" className="text-primary mx-auto" />
              <p className="text-sm text-muted-foreground" data-testid="forgot-success-msg">
                Eğer bu email kayıtlıysa şifre sıfırlama bağlantısı gönderildi.
                Lütfen gelen kutunuzu ve spam klasörünüzü kontrol edin.
              </p>
              <Button
                onClick={() => nav("/login")}
                className="w-full rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 uppercase tracking-widest font-semibold"
              >
                Girişe dön
              </Button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <p className="text-sm text-muted-foreground">
                Kayıtlı email adresinizi girin, size şifre sıfırlama bağlantısı göndereceğiz.
              </p>
              <div>
                <Label htmlFor="email">
                  <EnvelopeSimple size={14} className="inline mr-1" /> Email
                </Label>
                <Input
                  id="email"
                  type="email"
                  data-testid="forgot-email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1.5 rounded-sm"
                  required
                />
              </div>
              <Button
                type="submit"
                disabled={loading}
                data-testid="forgot-submit-btn"
                className="w-full rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 font-semibold uppercase tracking-widest"
              >
                {loading ? "Gönderiliyor..." : "Sıfırlama bağlantısı gönder"}
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
